export const FILTERS = {
  action: "Actions",
  view: "Viewed Job",
  status: "Status Change",
  edit: "Edit",
  event: "Update",
  notification: "Notification",
  close: "Close",
} as const;
